import { render, staticRenderFns } from "./StudentCard.vue?vue&type=template&id=2779d5b4&scoped=true"
import script from "./StudentCard.vue?vue&type=script&lang=js"
export * from "./StudentCard.vue?vue&type=script&lang=js"
import style0 from "./StudentCard.vue?vue&type=style&index=0&id=2779d5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779d5b4",
  null
  
)

export default component.exports